import o from"styled-components";const i=o.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	overflow: auto;
	position: relative;
	align-items: center;
	padding: 80px 32px;
	gap: 32px;
	overflow-y: auto;
`,e=o.div`
	cursor: pointer;
	width: 862px;

	height: auto;
	overflow: visible;
`;export{e as PreviewBlockContainer,i as PreviewContainer};
